export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-GB": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page not found!"])},
        "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We are sorry, we couldn't find the page you requested"])}
      },
      "nl-NL": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina niet gevonden!"])},
        "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excuses, de pagina kon niet worden gevonden"])}
      }
    }
  })
}
